<script>
import SelectComponent from '@/plugins/form/__components/SelectOne.vue';
import MixinItem from '@/plugins/form/__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    SelectComponent,
  },
};
</script>
<template>
  <SelectComponent
    class="f-flex__auto"
    :value="value"
    :placeholder="placeholder"
    :disabled="module.disabled"
    :options="module.options"
    :multiple="module.multiple"
    :clearable="module.clearable"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
